import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';
import { languagesHelper as language } from '../../util/languages';
import { normalizeTranslations, localizePageAssetData } from '../../util/cmsPageHelper';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const {
    params,
    pageAssetsData,
    landingPageData,
    inProgress,
    error,
    pageTranslations,
    scrollingDisabled,
    onManageDisableScrolling
  } = props;

  const pageId = params.pageId || props.pageId;

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  const locale = language.get();
  const originalPage = pageAssetsData?.[pageId]?.data || {};

  const rawTranslations = pageTranslations || {};
  const userTranslations = normalizeTranslations(rawTranslations);

  const localizedPage = localizePageAssetData(originalPage, userTranslations, locale);

  return (
    <PageBuilder
      pageAssetsData={localizedPage}
      landingPageData={landingPageData}
      pageId={pageId}
      inProgress={inProgress}
      schemaType="Article"
      topbarFixed
      scrollingDisabled={scrollingDisabled}
      onManageDisableScrolling={onManageDisableScrolling}
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  landingPageData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, landingPageData, inProgress, error } = state.hostedAssets || {};
  const { pageTranslations } = state.EditTranslationsPage || {};

  return {
    pageAssetsData,
    landingPageData,
    inProgress,
    error,
    pageTranslations,
    scrollingDisabled: isScrollingDisabled(state)
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CMSPageComponent);

export default CMSPage;
